// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { wishListSharingStatusStyles } from "@insite/content-library/Components/WishListSharingStatus";
import { screen } from "@rugby/XDL/Helpers";
import { color } from "@rugby/XDL/Utilities";
import { css } from "styled-components";

wishListSharingStatusStyles.privateTooltip = {
    ...wishListSharingStatusStyles.privateTooltip,
    cssOverrides: {
        ...wishListSharingStatusStyles?.privateTooltip?.cssOverrides,
        tooltipContainer: css`
            z-index: 432;
            background: ${color("common.white")};
            box-shadow: 0 0 15px 0 ${color("secondary", 0.25)};
            &::after {
                border-color: ${color("common.white")} transparent transparent transparent;
            }
            ${screen("lte", "xs")`
                margin-left: -40px;
                &::after {
                    left: 40px;
                }
            `}
        `,
    },
};
